module.exports = __webpack_public_path__ + "sky.7bc9eaa7313d46291119.png";


//////////////////
// WEBPACK FOOTER
// D:/ptrans/front-end-customer/src/assets/images/themes/footer/style06/sky.png
// module id = ../../../../../src/assets/images/themes/footer/style06/sky.png
// module chunks = 2